<script>
  import Card from '/components/Atoms/Card.svelte'
  import {formatDate} from '/helper'

  export let item

  const link={
    slug: item.slug,
    section: "news"
  }

</script>

<Card bgColorKey="red" {link} paddingStyle="article">
  <h3 class="title">
    {formatDate(new Date(item.postDate), 'event-day-month-year')}
  </h3>
  <p class="text">
    {item.title}
  </p>
</Card>

<style lang="scss">

  .title, .text {
    color: white;
  }

  .title {
    @include typo-grotesk-title-captions-20;
  }

  .text {
    margin-top: 1em;
    @include typo-serif-text-28;
  }


</style>

